import { SchedulingMode } from '../../constants'
import { useSchedulingMode } from '../useSchedulingMode'

const useIsPartnerPortalNeoSchedulingMode = () => {
  const mode = useSchedulingMode()

  return mode === SchedulingMode.PARTNER_PORTAL_NEO
}

export { useIsPartnerPortalNeoSchedulingMode }
